import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../components/AuthProvider';
import AdminSignUpForm from '../../forms/admin/AdminSignUpForm';
import { signUpUser } from '../../services/UserAuthService';
import '../../styles/admin/AdminSignUpPage.css';
import bannerImage from '../../../images/AuthPage/TravelWebKitBase_AdminAuthBanner.png';
import whiteLogo from '../../../images/Logo/MrSea2025_logo_white.png'

const AdminSignUpPage = () => {
  const navigate = useNavigate();
  const { userLogin, userData } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
  });
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const MAX_EMAIL_LENGTH = 320;
  const MAX_PASSWORD_LENGTH = 128;

  useEffect(() => {
    if (userData && userData.is_admin) {
      navigate('/admin');
    }
  }, [userData, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validateForm = () => {
    const { firstName, lastName, email, password, confirmPassword } = formData;
  
    if (!firstName || !lastName || !email || !password || !confirmPassword) {
      return 'Please fill out all fields.';
    }
  
    if (email.length > MAX_EMAIL_LENGTH) {
      return `Email cannot exceed ${MAX_EMAIL_LENGTH} characters.`;
    }
  
    if (!validateEmail(email)) {
      return 'Please enter a valid email address.';
    }
  
    if (password.length > MAX_PASSWORD_LENGTH) {
      return `Password cannot exceed ${MAX_PASSWORD_LENGTH} characters.`;
    }
  
    if (password !== confirmPassword) {
      return 'Passwords do not match.';
    }
  
    return '';
  };

  const handleSignUp = async () => {
    setFormSubmitted(true);
    
    const validationError = validateForm();
  
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }
    
    setLoading(true);
    setErrorMessage('');
  
    const data = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      password: formData.password,
      phone: formData.phone,
      is_superuser: true,
    };
  
    try {
      const registerData = await signUpUser(data);
  
      if (registerData.success) {
        const loginResult = await userLogin({ email: data.email, password: data.password });
        if (loginResult.success) {
          navigate('/user-account');
        } else {
          setErrorMessage('Error during login: ' + loginResult.message);
        }
      } else {
        setErrorMessage(registerData.message);
      }
    } catch (error) {
      setErrorMessage('Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const { firstName, lastName, email, password, confirmPassword, phone } = formData;

  return (
    <div className="admin__signup-page">
      <div className="auth-page__structure">
        <div className="auth-page__banner">
          <img src={bannerImage} alt="Hero Banner"/>
        </div>
        <div className="auth-page__content">
          <div className="auth-page__left">
            <div className="auth_page__cta">
              <div className="auth_page__cta-container">
                <img src={whiteLogo} alt="Company Logo" className="auth_page__logo" />
              </div>
            </div>
          </div>

          <div className="auth-page__right">
            <div className="admin__signup-page__card">
              <div className="admin__signup-page__intro">
                <h2>Sign Up</h2>
                <p>Already have an account? <a href="/admin/login">Login here</a></p>
              </div>
              <AdminSignUpForm
                firstName={firstName}
                lastName={lastName}
                email={email}
                password={password}
                confirmPassword={confirmPassword}
                phone={phone}
                errorMessage={errorMessage}
                loading={loading}
                formSubmitted={formSubmitted}
                handleChange={handleChange}
              />
              <div className="admin__signup-page__buttons">
                <button
                  className="button"
                  onClick={handleSignUp}
                  disabled={loading || !firstName || !lastName || !email || !password || !confirmPassword || !phone}
                >
                  {loading ? 'Signing up...' : 'Sign Up'}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AdminSignUpPage;